import React, { useState } from "react";
import PropTypes from "prop-types";
import ModalWrapper from "./ModalWrapper";
import tcbase from "../shim/tcbase";

const { urls: { static: staticFolder } = {} } = tcbase || {};

const imgClassificationMapping = `${staticFolder}images/rca2-mpw-legend-classification-mapping-v2.png`;
const imgFactorMapping = `${staticFolder}images/rca2-mpw-legend-factor-mapping.png`;

const MethodologyPopup = ({ open, onClose }) => {
  const [openModal, setOpenModal] = useState(open);
  const toggleModal = () => {
    setOpenModal(!openModal);
    onClose();
  };
  return (
    openModal && (
      <ModalWrapper
        show
        title="Methodology / Legend (Classification and Threat Level Mapping)"
        onHide={toggleModal}
        size="lg"
        className="modal--text-content"
      >
        <p>
          ReversingLabs&apos; new unified classification algorithm (RCA2)
          improves file classification reliability for users. RCA2 Risk Score /
          Factor (Values 0-10) replaces legacy Threat Level and Trust Factor
          (Values 0-5) on the Spectra Analyze appliance.
        </p>
        <p>
          <b>
            <i>RCA2 Classification - MWP Classification Mapping</i>
          </b>
        </p>
        <img src={imgClassificationMapping} />

        <p>
          <b>
            <i>RCA2 Factor - MWP Threat Level / Trust Factor Mapping</i>
          </b>
        </p>
        <img src={imgFactorMapping} />
      </ModalWrapper>
    )
  );
};

MethodologyPopup.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
};

export default MethodologyPopup;
